const timestampLinks = Array.from(document.querySelectorAll('[data-video-timestamp]'));

timestampLinks.forEach(link => link.addEventListener('click', e => {
    const timestampLink = e.target;
    const video = document.getElementById(timestampLink.getAttribute('aria-controls'));
    if (!video) return;
    const timestamp = Number(timestampLink.dataset.videoTimestamp);
    video.currentTime = timestamp;
    e.preventDefault();
}))
